var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.show_drawer)?_c('NavigationMenu'):_vm._e(),_c('v-main',[_c('router-view'),_c('NotiBox')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }